export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Cobalt Blue-1.cc2b8a2a.jpg";